import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["className", "size", "style", "icon", "showButton", "buttonColor", "buttonText"];
import React from 'react';
import classNames from 'classnames';
import { SearchBox as SBox } from '@elastic/react-search-ui';
import { Button, Input } from 'reactstrap';
var blockClass = 'search-box';
var SearchBox = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchBox, _React$Component);
  function SearchBox(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: ''
    };
    return _this;
  }
  var _proto = SearchBox.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      size = _this$props.size,
      style = _this$props.style,
      icon = _this$props.icon,
      showButton = _this$props.showButton,
      buttonColor = _this$props.buttonColor,
      buttonText = _this$props.buttonText,
      attrs = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var classes = classNames(blockClass, 'position-relative', size ? blockClass + "--" + size : '', className);
    return /*#__PURE__*/React.createElement("div", {
      className: classes,
      style: style
    }, /*#__PURE__*/React.createElement(SBox, _extends({
      className: classes,
      inputView: function inputView(_ref) {
        var getAutocomplete = _ref.getAutocomplete,
          getInputProps = _ref.getInputProps,
          getButtonProps = _ref.getButtonProps;
        var containerClasses = classNames(blockClass + "__container", showButton ? blockClass + "__container--with-btn" : '');
        return /*#__PURE__*/React.createElement("div", {
          className: containerClasses
        }, /*#__PURE__*/React.createElement(Input, _extends({}, getInputProps(), {
          type: "search",
          className: blockClass + "__input",
          bsSize: size
        })), showButton && /*#__PURE__*/React.createElement(Button, _extends({}, getButtonProps(), {
          className: blockClass + "__btn",
          color: buttonColor,
          size: size
        }), buttonText), getAutocomplete());
      },
      autocompleteView: function autocompleteView(_ref2) {
        var autocompletedResults = _ref2.autocompletedResults,
          getItemProps = _ref2.getItemProps;
        return /*#__PURE__*/React.createElement("ul", {
          className: blockClass + "__autocomplete list-unstyled"
        }, autocompletedResults.map(function (result, i) {
          return /*#__PURE__*/React.createElement("li", _extends({
            className: blockClass + "__autocomplete-result text-wrap"
          }, getItemProps({
            key: i,
            item: result
          }), {
            dangerouslySetInnerHTML: {
              __html: result.title.snippet || result.title.raw
            }
          }));
        }));
      }
    }, attrs)), icon && /*#__PURE__*/React.createElement("span", {
      className: blockClass + "__icon"
    }, icon));
  };
  return SearchBox;
}(React.Component);
export { SearchBox as default };
SearchBox.defaultProps = {
  autocompleteMinimumCharacters: 2,
  icon: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M0 0h24v24H0z"
  })),
  showButton: true,
  buttonColor: 'primary',
  buttonText: 'Search'
};